import React from "react";
import type { Opportunity } from "@app-redux/slices/opportunitySlice";
import type { ColumnDef } from "./columnConfig";
import { OpportunityRow } from "./OpportunityRow";
import { AddOpportunityRow } from "./AddOpportunityRow";
import styles from "./styles.module.css";

type Props = {
  opportunities: Opportunity[];
  isAdmin: boolean;
  isAddingRow: boolean;
  onCancelAdd: () => void;
  selectedCategoryId: string;
  columns: ColumnDef[];
};

export const OpportunityTable = ({
  opportunities,
  isAdmin,
  isAddingRow,
  onCancelAdd,
  selectedCategoryId,
  columns,
}: Props) => {
  return (
    <table aria-label="Opportunities table" className={styles.table}>
      <colgroup>
        {columns.map((col) => (
          <col key={col.field} width={col.width} />
        ))}
        {isAdmin && <col width="7%" />}
      </colgroup>
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.field}>{col.header}</th>
          ))}
          {isAdmin && <th>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {isAddingRow && (
          <AddOpportunityRow
            categoryId={selectedCategoryId}
            onCancel={onCancelAdd}
            columns={columns}
          />
        )}
        {opportunities.map((opp) => (
          <OpportunityRow
            key={opp.id}
            opportunity={opp}
            isAdmin={isAdmin}
            columns={columns}
          />
        ))}
      </tbody>
    </table>
  );
};
